import styled from '@emotion/styled';
import {Positionable} from '@travel-frontend/ui-components';

export const PositionableNonBlocking = styled(Positionable)`
  /* Don't block swiping inside the image carousel */
  pointer-events: none;
`;
